import { useState, useEffect } from 'react';
import { getDevopsSwitchStatus } from '@util';

/**
 * 特性开关hooks
 * @param {string} code 特性开关key
 * @param {string} project 特性开关项目
 * @example
 * const status = useDevopsSwitch(code, project)
 *
 * @returns boolean
 */
export default (code: string, project?: string, globalLoading?: boolean) => {
  const [switchStatus, setSwitchStatus] = useState<boolean | undefined>(undefined);

  const getSwitchStatus = async () => {
    if (!code) {
      return;
    }

    const status = await getDevopsSwitchStatus(code, project);

    setSwitchStatus(status);
  };

  useEffect(() => {
    getSwitchStatus();
  }, []);

  return switchStatus;
};
